import { render, staticRenderFns } from "./FormChipsSelector.vue?vue&type=template&id=7f08fc26&scoped=true"
import script from "./FormChipsSelector.vue?vue&type=script&lang=js"
export * from "./FormChipsSelector.vue?vue&type=script&lang=js"
import style0 from "./FormChipsSelector.vue?vue&type=style&index=0&id=7f08fc26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f08fc26",
  null
  
)

export default component.exports